import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../store';

export type PagePrompt = Readonly<{
  promptButtonId: string;
  title: string;
}>;

type PagePromptsState = Readonly<{
  prompts: PagePrompt[];
}>;

const initialState: PagePromptsState = {
  prompts: [],
};

export const pagePromptsSlice = createSlice({
  name: 'pagePrompts',
  initialState,
  reducers: {
    setPagePrompts: (state, action: PayloadAction<readonly PagePrompt[]>) => {
      state.prompts = [...action.payload];
    },
    clearPagePrompts: (state) => {
      state.prompts = [];
    },
  },
});

export const { setPagePrompts, clearPagePrompts } = pagePromptsSlice.actions;

export const selectPagePrompts = (state: RootState) => state.pagePrompts.prompts;
